import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from 'src/app/constants';

@Pipe({
    name: 'statusLabel',
    standalone: false
})
export class StatusLabelPipe implements PipeTransform {
    private translations: any;

    constructor(
        private translateService: TranslateService
    ) { }

    async transform(status: number): Promise<string> {
        if (!this.translations) {
            this.translations = (await this.translateService.get('MISSION').toPromise())['CONFIG_STATUS'];
        }
        const STATUS = CONSTANTS.MISSION.CONFIG_STATUS;
        switch (status) {
            case STATUS.IN_PROGRESS:
                return this.translations['IN_PROGRESS'];
            case STATUS.COMPLETED:
                return this.translations['COMPLETED'];
            case STATUS.BLOCKED:
                return this.translations['BLOCKED'];
            case STATUS.NOT_STARTED:
            default:
                return this.translations['NOT_STARTED'];
        }
    }
}
